import Home from "./views/Home";
import HomeDRH from "./views/HomeDRH";
import PublicPage from "./views/PublicPage";
import OnlyAnonPage from "./views/OnlyAnonPage";
import AuthenticatedPage from "./views/AuthenticatedPage";
import AuthAndAutorizedPage from "./views/AuthAndAutorizedPage";
import MaskedPage from "./views/MaskedPage";
import About from "./views/About";
import Recherche from "./views/Recherche";
import Tools from "./views/Tools";
import BaseError from "./views/base/BaseError";
import FormComplementaire from "./views/FormComplementaire";
import DRHComplementaire from "./views/DRHComplementaire";
import IndividuData from "./views/IndividuData";
import InitialisationLot from "./views/InitialisationLot";
import FormComplementaireWinpaie from "./views/FormComplementaireWinpaie";
import FormComplementaireWPRH from "./views/FormComplementaireWPRH";
import Droit from "./views/Droit";
import Contrat from "./views/Contrat";
import Parametres from "./views/Parametres";
import Processus from "./views/Processus";
import RIB from "./views/RIB";
import DRHRIB from "./views/DRHRIB";
import Insee from "./views/Insee";
import DRHInsee from "./views/DRHInsee";
import depotPiece from "./views/DepotPiece";
import adresse from "./views/adresse";
import telephone from "./views/telephone";
import DRHDepotPiece from "./views/DRHDepotPiece";
import Messagerie from "./components/Messagerie";
import Ensap from "./views/ensap";
import TInfo from "./views/TInfo";
import Structure from "./views/structure";

//nombre de page - 1 avant les sous-menu déroulant
let position = 2;

export default {
  definition: [
    // définition des routes :
    /**
     * - path: chemin relatif
     * - name: nom identifiant la route (unique)
     * - icon: icône materiel-design pour le lien dans le menu
     * - title: titre du lien dans le menu
     *
     * - meta: {
     *
     *   - title: titre de la page (balise <title> du <head> HTML)
     *   - menu: doit apparaître dans le menu
     *
     *   - access:
     *     - type: "public" | "anonymous" | "authenticated" | "authorized"
     *        "public"        => Page accès anonyme : toujours présente
     *        "anonymous"     => Page accès anonyme uniquement : présente uniquement si utilisateur non connecté
     *        "authenticated" => Page authentifiée : présente si utilisateur connecté et a les droits pour cela
     *     - roles: si route "authorized", liste des roles user ayant accès à cette route
     *   }
     * }
     */
    {
      path: "/",
      name: "home",
      icon: "dashboard",
      title: "Accueil",
      component: Home,
      meta: {
        title: "Accueil",
        menu: true,
        access: {
          type: "public",
        },
      },
    },
    // {
    //   path: "/public-page",
    //   name: "public-page",
    //   icon: "public",
    //   title: "Page publique",
    //   component: PublicPage,
    //   meta: {
    //     title: "Page publique",
    //     menu: true,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },
    // {
    //   path: "/anonymous-page",
    //   name: "anonymous-page",
    //   icon: "public",
    //   title: "Page anonyme uniquement",
    //   component: OnlyAnonPage,
    //   meta: {
    //     title: "Page anonyme uniquement",
    //     menu: true,
    //     access: {
    //       type: "anonymous"
    //     }
    //   }
    // },
    {
      path: "/individu-data",
      name: "individu-data",
      icon: "mdi-account",
      title: "Données individu",
      component: IndividuData,
      meta: {
        title: "Données individu",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/formulaire-complementaire-sante",
      name: "formulaire-complementaire-sante",
      icon: "medical_information",
      title: "Complémentaire Santé",
      tuile: true,
      component: FormComplementaire,
      meta: {
        title: "formulaire Complementaire Sante",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      // [
      title: "DRH",
      icon: "mdi-google",
      path: "",
      tuile: true,
      meta: {
        title: "DRH",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "SUPERADMIN", "CONSULTATION"],
        },
      },
      name: "DRH",
      definition: [{ id: position + 9 }],
      section: [
        // {
        //   path: "/auth-page-limited",
        //   name: "auth-page-limited",
        //   icon: "security",
        //   title: "Page authentifiée et autorisée",
        //   component: AuthAndAutorizedPage,
        //   meta: {
        //     title: "Page authentifiée et autorisée",
        //     menu: true,
        //     access: {
        //       type: "authenticated",
        //       roles: ["ROLE_SWITCH"]
        //     }
        //   }
        // },
        // {
        //   path: "/DRHComplementaire",
        //   name: "DRH Complementaire",
        //   icon: "security",
        //   title: "DRH Complémentaire",
        //   component: DRHComplementaire,
        //   meta: {
        //     title: "DRH Complémentaire",
        //     menu: true,
        //     access: {
        //       type: "authenticated",
        //       roles: ["GRH", "ADMIN"],
        //     },
        //   },
        // },
        // {
        //   path: "/lots",
        //   name: "Initialisation des lots",
        //   icon: "security",
        //   title: "Initialisation des lots",
        //   component: InitialisationLot,
        //   meta: {
        //     title: "Initialisation des lots",
        //     menu: true,
        //     access: {
        //       type: "authenticated",
        //       roles: ["GRH", "ADMIN"],
        //     },
        //   },
        // },
        // {
        //   path: "/winpaie",
        //   name: "Transmission vers winpaie",
        //   icon: "mdi-currency-eur",
        //   title: "Transmission vers winpaie",
        //   component: FormComplementaireWinpaie,
        //   meta: {
        //     title: "Transmission vers winpaie",
        //     menu: true,
        //     access: {
        //       type: "authenticated",
        //       roles: ["GRH", "ADMIN"],
        //     },
        //   },
        // },
        {
          name: "Formulaire Complémentaire",
          links: [
            { id: position + 3 },
            { id: position + 4 },
            { id: position + 5 },
          ], //links possède l'index du tableau des routes
        },
      ],
    },
    // ],
    {
      path: "",
      name: "Administration",
      icon: "mdi-account-circle",
      title: "Administration",
      tuile: true,
      meta: {
        title: "Administration",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ADMIN", "SUPERADMIN"],
        },
      },
      definition: [
        { id: position + 6 },
        { id: position + 7 },
        { id: position + 8 },
        { id: position + 10 },
        // {
        //   path: "/droits",
        //   name: "Gestion des droits d'utilisateurs",
        //   icon: "security",
        //   title: "Gestion des droits d'utilisateurs",
        //   component: Droit,
        //   meta:
        //   {
        //     title: "Gestion des droits d'utilisateurs",
        //     menu: true,
        //     access:
        //     {
        //       type: "authenticated",
        //       roles: ["ADMIN"],
        //     },
        //   },
        // }
      ],
    },
    // {
    //   path: "/auth-page-limited",
    //   name: "auth-page-limited",
    //   icon: "security",
    //   title: "Page authentifiée et autorisée",
    //   component: AuthAndAutorizedPage,
    //   meta: {
    //     title: "Page authentifiée et autorisée",
    //     menu: true,
    //     access: {
    //       type: "authenticated",
    //       roles: ["ROLE_SWITCH"]
    //     }
    //   }
    // },
    {
      path: "/DRHComplementaire",
      name: "DRH Complementaire",
      icon: "mdi-folder-information",
      title: "Gestion des demandes",
      component: DRHComplementaire,
      meta: {
        title: "DRH Complémentaire",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/lots",
      name: "Initialisation des lots",
      icon: "mdi-package-variant-closed",
      title: "Gestion des lots",
      component: InitialisationLot,
      meta: {
        title: "Initialisation des lots",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "CONSULTATION", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/wprh",
      name: "Transmission vers WPRH",
      icon: "mdi-currency-eur",
      title: "Transmission vers winpaie",
      component: FormComplementaireWPRH,
      meta: {
        title: "Transmission vers WPRH",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/winpaie",
      name: "Transmission vers winpaie",
      icon: "mdi-currency-eur",
      title: "Transmission vers winpaie",
      component: FormComplementaireWinpaie,
      meta: {
        title: "Transmission vers winpaie",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/droits",
      name: "Gestion des droits d'utilisateurs",
      icon: "security",
      title: "Gestion des droits d'utilisateurs",
      component: Droit,
      meta: {
        title: "Gestion des droits d'utilisateurs",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/contrats",
      name: "Gestion des statuts",
      icon: "assignment",
      title: "Gestion des statuts",
      component: Contrat,
      meta: {
        title: "Gestion des statuts",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/parametres",
      name: "Gestion des paramètres",
      icon: "settings",
      title: "Gestion des paramètres",
      component: Parametres,
      meta: {
        title: "Gestion des paramètres",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/structure",
      name: "Gestion des structures",
      icon: "mdi-account-group",
      title: "Gestion des structures",
      component: Structure,
      meta: {
        title: "Gestion des structures",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/AccueilDRH",
      name: "Accueil",
      icon: "home",
      title: "Accueil",
      component: HomeDRH,
      meta: {
        title: "Accueil",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "SUPERADMIN"],
        },
      },
    },
    {
      path: "/processus",
      name: "Gestion des tuiles",
      icon: "",
      title: "Gestion des tuiles",
      component: Processus,
      meta: {
        title: "Gestion des tuiles",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["SUPERADMIN"],
        },
      },
    },
    {
      path: "/Ensap",
      name: "Ensap",
      component: Ensap,
      meta: {
        title: "Ensap",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/info/:type",
      name: "TInfo",
      component: TInfo,
      meta: {
        title: "Info",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/RIB",
      name: "Changement de RIB",
      component: RIB,
      meta: {
        title: "Changement de RIB",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/DRHRIB",
      name: "Changement de RIB - DRH",
      component: DRHRIB,
      meta: {
        title: "Changement de RIB - DRH",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN"],
        },
      },
    },
    {
      path: "/Insee",
      name: "Changement de Insee",
      component: Insee,
      meta: {
        title: "Changement de Insee",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/DRHInsee",
      name: "Changement de Insee - DRH",
      component: DRHInsee,
      meta: {
        title: "Changement de Insee - DRH",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN"],
        },
      },
    },
    {
      path: "/SituationFamiliale",
      name: "Changement de Situation Familiale",
      component: depotPiece,
      meta: {
        title: "Changement de Situation Familiale",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/EtatCivil",
      name: "Etat Civil",
      component: depotPiece,
      meta: {
        title: "Etat Civil",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/DRHSituationFamiliale",
      name: "Situation Administrative",
      component: DRHDepotPiece,
      meta: {
        title: "Demandes situation administrative",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["GRH", "ADMIN", "CONSULTATION_PIECE"],
        },
      },
    },
    {
      path: "/consultationSituationFamiliale",
      name: "Consultation des pièces",
      component: DRHDepotPiece,
      meta: {
        title: "Consultation des pièces",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["CONSULTATION_PIECE"],
        },
      },
    },
    {
      path: "/Adresse",
      name: "Adresse",
      component: adresse,
      meta: {
        title: "Adresse",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/telephone",
      name: "telephone",
      component: telephone,
      props: true,
      meta: {
        title: "Téléphone",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["PERSONNEL"],
        },
      },
    },
    {
      path: "/messagerie",
      name: "messagerie",
      component: Messagerie,
      props: true,
      meta: {
        title: "Messagerie",
        sousMenu: true,
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ADMIN"],
        },
      },
    },
    // { //si on le met avant les sousPages, le comportement est différent pour les arrows
    //   path: "/about",
    //   name: "about",
    //   icon: "question_answer",
    //   title: "A propos",
    //   component: About,
    //   meta: {
    //     title: "A propos",
    //     menu: true,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },
    // {
    //   path: "/recherche",
    //   name: "recherche",
    //   icon: "mdi-magnify",
    //   title: "Page de recherche",
    //   component: Recherche,
    //   meta: {
    //     title: "Page de recherche",
    //     menu: true,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },
    // {
    //   path: "/tools",
    //   name: "outils",
    //   icon: "build",
    //   title: "Page d'outils",
    //   component: Tools,
    //   meta: {
    //     title: "Page d'outils",
    //     menu: true,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },

    // {
    //   path: "/masked",
    //   name: "masked",
    //   title: "Page masquée",
    //   component: MaskedPage,
    //   meta: {
    //     title: "Page masquée",
    //     menu: false,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },
    // {
    //   path: "/erreur",
    //   name: "erreur",
    //   component: BaseError,
    //   props: {
    //     message: "Une erreur est survenue"
    //   },
    //   meta: {
    //     title: "Page d'erreur",
    //     menu: false,
    //     access: {
    //       type: "public"
    //     }
    //   }
    // },

    {
      path: "*",
      name: "notfound",
      component: BaseError,
      props: {
        message: "La page spécifiée est introuvable",
      },
      meta: {
        title: "Page non trouvée",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: BaseError,
      props: {
        message: "Vous n'êtes pas autorisé à accéder à cette page",
      },
      meta: {
        title: "Ressource non autorisée",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
  ],
};
